<template>
  <MainProductModule />
</template>

<script>
import MainProductModule from '@/modules/masterData/mainProducts/components/main.vue';

export default {
  name: 'MasterDataMainProducts',
  components: {
    MainProductModule,
  },
};
</script>
